import { SVGProps } from "react";

export default function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ?? "24"}
      height={props.height ?? "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 21.75C5.85 21.75 1.25 17.15 1.25 11.5C1.25 5.85 5.85 1.25 11.5 1.25C17.15 1.25 21.75 5.85 21.75 11.5C21.75 17.15 17.15 21.75 11.5 21.75ZM11.5 2.75C6.67 2.75 2.75 6.68 2.75 11.5C2.75 16.32 6.67 20.25 11.5 20.25C16.33 20.25 20.25 16.32 20.25 11.5C20.25 6.68 16.33 2.75 11.5 2.75Z"
        className={props.className || "fill-outext-main  stroke-outext-main"}
      />
      <path
        d="M21.9999 22.2499C21.9354 22.2499 21.8748 22.2277 21.8235 22.1764L19.8235 20.1764C19.7288 20.0817 19.7288 19.9182 19.8235 19.8235C19.9182 19.7288 20.0817 19.7288 20.1764 19.8235L22.1764 21.8235C22.2711 21.9182 22.2711 22.0817 22.1764 22.1764C22.1251 22.2277 22.0645 22.2499 21.9999 22.2499Z"
        className={props.className || "fill-outext-main stroke-outext-main"}
      />
    </svg>
  );
}
